var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "task-step-specific-info-card" }, [
    !_vm.stepInfo
      ? _c("div", { staticClass: "no object-card" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("SelectStep")))])
        ])
      : _c(
          "div",
          { style: { height: "100%" } },
          [
            _c("tabs", {
              attrs: {
                tabs: _vm.tabs,
                "active-tab": _vm.activeTab,
                "tabs-styling": _vm.tabsStyling,
                "tabs-labels-styling": _vm.tabsLabelsStyling,
                "center-tabs": false
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { id: "fields-div" } },
              [
                _c("fields-list", {
                  style: { "flex-grow": "0" },
                  attrs: {
                    id: "common-task-fields-div",
                    fields: _vm.fields,
                    "editing-data": false,
                    "hide-lines": true
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "task-value-container",
                    style: {
                      padding:
                        _vm.stepInfo.type === "photo"
                          ? "0px"
                          : "12px 0 7.5px 20px"
                    }
                  },
                  [
                    _vm.stepInfo.type === "photo"
                      ? _c("div", { staticClass: "photo" }, [
                          !_vm.stepInfo.value
                            ? _c(
                                "div",
                                { staticClass: "no-photo" },
                                [_c("v-icon", [_vm._v("photo_camera")])],
                                1
                              )
                            : _c("img", {
                                staticClass: "task-photo",
                                attrs: {
                                  src: _vm.stepInfo.value,
                                  alt: "Task Photo"
                                }
                              })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.stepInfo.type === "text"
                      ? _c(
                          "div",
                          { staticClass: "text" },
                          [
                            _c("v-icon", [_vm._v("subject")]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.stepInfo.value))])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.stepInfo.type === "checkbox"
                      ? _c(
                          "div",
                          { staticClass: "checkbox" },
                          [
                            _c("v-icon", [
                              _vm._v(
                                _vm._s(
                                  _vm.stepInfo.value === true
                                    ? "check"
                                    : "check_box_outline_blank"
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.stepInfo.value
                                    ? _vm.$t("Done")
                                    : _vm.$t("NotFinished")
                                )
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02728be1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02728be1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/TasksManagement/TaskStepSpecificInfo.vue
// module id = null
// module chunks = 